import { FC } from "react";
import logoutIcon from '../assets/svgs/logout.svg'
import './Logout.scss';

export type LogoutButtonProps = {
  logout: Function
};

const LogoutButton: FC<LogoutButtonProps> = (props) => {

  return (
    <div className='logout-button' onClick={props.logout as any}> <img src={logoutIcon} className='logout-icon'></img> Logout</div>
  );
}

export default LogoutButton;
